export const questionsData = [
  {
    img: "/games/own-it/img/question_1.gif",
    options: [
      [
        {
          img: "/games/own-it/img/result_1_1_1.gif",
          progress: {
            money: -2,
            trust: 0,
            fame: -1,
          },
        },
        {
          img: "/games/own-it/img/result_1_1_2.gif",
          progress: {
            money: 0,
            trust: 0,
            fame: 1,
          },
        },
        {
          img: "/games/own-it/img/result_1_1_3.gif",
          progress: {
            money: 1,
            trust: 0,
            fame: 1,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_1_2_1.gif",
          progress: {
            money: -3,
            trust: 0,
            fame: -1,
          },
        },
        {
          img: "/games/own-it/img/result_1_2_2.gif",
          progress: {
            money: 1,
            trust: 1,
            fame: 2,
          },
        },
        {
          img: "/games/own-it/img/result_1_2_3.gif",
          progress: {
            money: -1,
            trust: 0,
            fame: 1,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_1_3_1.gif",
          progress: {
            money: -3,
            trust: 1,
            fame: 1,
          },
        },
        {
          img: "/games/own-it/img/result_1_3_2.gif",
          progress: {
            money: -6,
            trust: 0,
            fame: -1,
          },
        },
        {
          img: "/games/own-it/img/result_1_3_3.gif",
          progress: {
            money: -1,
            trust: 0,
            fame: 1,
          },
        },
      ],
    ],
  },
  {
    img: "/games/own-it/img/question_2.gif",
    options: [
      [
        {
          img: "/games/own-it/img/result_2_1_1.gif",
          progress: {
            money: -2,
            trust: 0,
            fame: -1,
          },
        },
        {
          img: "/games/own-it/img/result_2_1_2.gif",
          progress: {
            money: -4,
            trust: -2,
            fame: -2,
          },
        },
        {
          img: "/games/own-it/img/result_2_1_3.gif",
          progress: {
            money: 2,
            trust: 2,
            fame: 3,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_2_2_1.gif",
          progress: {
            money: -2,
            trust: 0,
            fame: -2,
          },
        },
        {
          img: "/games/own-it/img/result_2_2_2.gif",
          progress: {
            money: -2,
            trust: -1,
            fame: -1,
          },
        },
        {
          img: "/games/own-it/img/result_2_2_3.gif",
          progress: {
            money: 2,
            trust: 2,
            fame: 2,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_2_3_1.gif",
          progress: {
            money: 2,
            trust: 3,
            fame: 3,
          },
        },
        {
          img: "/games/own-it/img/result_2_3_2.gif",
          progress: {
            money: -1,
            trust: 0,
            fame: -1,
          },
        },
        {
          img: "/games/own-it/img/result_2_3_3.gif",
          progress: {
            money: -3,
            trust: -1,
            fame: -2,
          },
        },
      ],
    ],
  },
  {
    img: "/games/own-it/img/question_3.gif",
    options: [
      [
        {
          img: "/games/own-it/img/result_3_1_1.gif",
          progress: {
            money: 0,
            trust: 3,
            fame: 3,
          },
        },
        {
          img: "/games/own-it/img/result_3_1_2.gif",
          progress: {
            money: 0,
            trust: -2,
            fame: -3,
          },
        },
        {
          img: "/games/own-it/img/result_3_1_3.gif",
          progress: {
            money: 0,
            trust: -1,
            fame: -1,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_3_2_1.gif",
          progress: {
            money: -4,
            trust: -1,
            fame: -2,
          },
        },
        {
          img: "/games/own-it/img/result_3_2_2.gif",
          progress: {
            money: -2,
            trust: 2,
            fame: 4,
          },
        },
        {
          img: "/games/own-it/img/result_3_2_3.gif",
          progress: {
            money: -1,
            trust: 0,
            fame: 0,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_3_3_1.gif",
          progress: {
            money: 0,
            trust: -1,
            fame: -1,
          },
        },
        {
          img: "/games/own-it/img/result_3_3_2.gif",
          progress: {
            money: -1,
            trust: 2,
            fame: 2,
          },
        },
        {
          img: "/games/own-it/img/result_3_3_3.gif",
          progress: {
            money: -1,
            trust: 0,
            fame: 0,
          },
        },
      ],
    ],
  },
  {
    img: "/games/own-it/img/question_4.gif",
    options: [
      [
        {
          img: "/games/own-it/img/result_4_1_1.gif",
          progress: {
            money: -2,
            trust: 0,
            fame: 0,
          },
        },
        {
          img: "/games/own-it/img/result_4_1_2.gif",
          progress: {
            money: -1,
            trust: 2,
            fame: 2,
          },
        },
        {
          img: "/games/own-it/img/result_4_1_3.gif",
          progress: {
            money: -3,
            trust: -3,
            fame: 0,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_4_2_1.gif",
          progress: {
            money: -2,
            trust: 0,
            fame: 0,
          },
        },
        {
          img: "/games/own-it/img/result_4_2_2.gif",
          progress: {
            money: -3,
            trust: 0,
            fame: 0,
          },
        },
        {
          img: "/games/own-it/img/result_4_2_3.gif",
          progress: {
            money: -1,
            trust: 1,
            fame: 0,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_4_3_1.gif",
          progress: {
            money: 0,
            trust: -1,
            fame: -1,
          },
        },
        {
          img: "/games/own-it/img/result_4_3_2.gif",
          progress: {
            money: -3,
            trust: 0,
            fame: 0,
          },
        },
        {
          img: "/games/own-it/img/result_4_3_3.gif",
          progress: {
            money: 4,
            trust: 2,
            fame: 1,
          },
        },
      ],
    ],
  },
  {
    img: "/games/own-it/img/question_5.gif",
    options: [
      [
        {
          img: "/games/own-it/img/result_5_1_1.gif",
          progress: {
            money: -3,
            trust: 5,
            fame: 5,
          },
        },
        {
          img: "/games/own-it/img/result_5_1_2.gif",
          progress: {
            money: -4,
            trust: -2,
            fame: -3,
          },
        },
        {
          img: "/games/own-it/img/result_5_1_3.gif",
          progress: {
            money: -3,
            trust: -3,
            fame: -5,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_5_2_1.gif",
          progress: {
            money: 0,
            trust: -3,
            fame: -4,
          },
        },
        {
          img: "/games/own-it/img/result_5_2_2.gif",
          progress: {
            money: 0,
            trust: 2,
            fame: 5,
          },
        },
        {
          img: "/games/own-it/img/result_5_2_3.gif",
          progress: {
            money: 0,
            trust: 0,
            fame: -1,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_5_3_1.gif",
          progress: {
            money: -3,
            trust: 0,
            fame: -3,
          },
        },
        {
          img: "/games/own-it/img/result_5_3_2.gif",
          progress: {
            money: -2,
            trust: 2,
            fame: 4,
          },
        },
        {
          img: "/games/own-it/img/result_5_3_3.gif",
          progress: {
            money: -3,
            trust: 0,
            fame: -2,
          },
        },
      ],
    ],
  },
  {
    img: "/games/own-it/img/question_6.gif",
    options: [
      [
        {
          img: "/games/own-it/img/result_6_1_1.gif",
          progress: {
            money: -2,
            trust: 2,
            fame: 0,
          },
        },
        {
          img: "/games/own-it/img/result_6_1_2.gif",
          progress: {
            money: -5,
            trust: -5,
            fame: -3,
          },
        },
        {
          lose: true,
        },
      ],
      [
        {
          img: "/games/own-it/img/result_6_2_1.gif",
          progress: {
            money: 1,
            trust: 2,
            fame: 1,
          },
        },
        {
          img: "/games/own-it/img/result_6_2_2.gif",
          progress: {
            money: -3,
            trust: -4,
            fame: -4,
          },
        },
        {
          img: "/games/own-it/img/result_6_2_3.gif",
          progress: {
            money: -1,
            trust: 0,
            fame: 0,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_6_3_1.gif",
          progress: {
            money: -2,
            trust: 3,
            fame: 3,
          },
        },
        {
          img: "/games/own-it/img/result_6_3_2.gif",
          progress: {
            money: -1,
            trust: -1,
            fame: -1,
          },
        },
        {
          lose: true,
        },
      ],
    ],
  },
  {
    img: "/games/own-it/img/question_7.gif",
    options: [
      [
        {
          img: "/games/own-it/img/result_7_1_1.gif",
          progress: {
            money: -2,
            trust: 5,
            fame: 5,
          },
        },
        {
          img: "/games/own-it/img/result_7_1_2.gif",
          progress: {
            money: -5,
            trust: -3,
            fame: -3,
          },
        },
        {
          img: "/games/own-it/img/result_7_1_3.gif",
          progress: {
            money: -2,
            trust: 0,
            fame: 0,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_7_2_1.gif",
          progress: {
            money: -1,
            trust: 2,
            fame: 4,
          },
        },
        {
          img: "/games/own-it/img/result_7_2_2.gif",
          progress: {
            money: -1,
            trust: 0,
            fame: 0,
          },
        },
        {
          img: "/games/own-it/img/result_7_2_3.gif",
          progress: {
            money: -3,
            trust: -3,
            fame: -3,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_7_3_1.gif",
          progress: {
            money: -3,
            trust: -4,
            fame: 1,
          },
        },
        {
          img: "/games/own-it/img/result_7_3_2.gif",
          progress: {
            money: -1,
            trust: 3,
            fame: 5,
          },
        },
        {
          img: "/games/own-it/img/result_7_3_3.gif",
          progress: {
            money: -3,
            trust: -1,
            fame: -3,
          },
        },
      ],
    ],
  },
  {
    img: "/games/own-it/img/question_8.gif",
    options: [
      [
        {
          img: "/games/own-it/img/result_8_1_1.gif",
          progress: {
            money: -3,
            trust: 3,
            fame: 3,
          },
        },
        {
          img: "/games/own-it/img/result_8_1_2.gif",
          progress: {
            money: 0,
            trust: -3,
            fame: -3,
          },
        },
        {
          img: "/games/own-it/img/result_8_1_3.gif",
          progress: {
            money: -1,
            trust: 1,
            fame: 1,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_8_2_1.gif",
          progress: {
            money: 0,
            trust: 4,
            fame: 4,
          },
        },
        {
          img: "/games/own-it/img/result_8_2_2.gif",
          progress: {
            money: 0,
            trust: 1,
            fame: 1,
          },
        },
        {
          img: "/games/own-it/img/result_8_2_3.gif",
          progress: {
            money: 0,
            trust: -3,
            fame: -3,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_8_3_1.gif",
          progress: {
            money: 1,
            trust: 5,
            fame: 2,
          },
        },
        {
          img: "/games/own-it/img/result_8_3_2.gif",
          progress: {
            money: -1,
            trust: -1,
            fame: -1,
          },
        },
        {
          lose: true,
        },
      ],
    ],
  },
  {
    img: "/games/own-it/img/question_9.gif",
    options: [
      [
        {
          img: "/games/own-it/img/result_9_1_1.gif",
          progress: {
            money: 0,
            trust: 2,
            fame: 2,
          },
        },
        {
          img: "/games/own-it/img/result_9_1_2.gif",
          progress: {
            money: 0,
            trust: -2,
            fame: -3,
          },
        },
        {
          img: "/games/own-it/img/result_9_1_3.gif",
          progress: {
            money: -1,
            trust: -1,
            fame: -1,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_9_2_1.gif",
          progress: {
            money: 0,
            trust: -3,
            fame: -2,
          },
        },
        {
          img: "/games/own-it/img/result_9_2_2.gif",
          progress: {
            money: 0,
            trust: 1,
            fame: 1,
          },
        },
        {
          img: "/games/own-it/img/result_9_2_3.gif",
          progress: {
            money: 0,
            trust: 3,
            fame: 3,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_9_3_1.gif",
          progress: {
            money: -1,
            trust: 1,
            fame: 1,
          },
        },
        {
          img: "/games/own-it/img/result_9_3_2.gif",
          progress: {
            money: -3,
            trust: -3,
            fame: -3,
          },
        },
        {
          img: "/games/own-it/img/result_9_3_3.gif",
          progress: {
            money: 5,
            trust: 5,
            fame: 5,
          },
        },
      ],
    ],
  },
  {
    img: "/games/own-it/img/question_10.gif",
    options: [
      [
        {
          img: "/games/own-it/img/result_10_1_1.gif",
          progress: {
            money: 4,
            trust: 3,
            fame: 3,
          },
        },
        {
          img: "/games/own-it/img/result_10_1_2.gif",
          progress: {
            money: -2,
            trust: -2,
            fame: -2,
          },
        },
        {
          img: "/games/own-it/img/result_10_1_3.gif",
          progress: {
            money: -2,
            trust: -5,
            fame: -2,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_10_2_1.gif",
          progress: {
            money: 1,
            trust: 1,
            fame: 1,
          },
        },
        {
          img: "/games/own-it/img/result_10_2_2.gif",
          progress: {
            money: 4,
            trust: 4,
            fame: 3,
          },
        },
        {
          img: "/games/own-it/img/result_10_2_3.gif",
          progress: {
            money: -2,
            trust: 0,
            fame: 0,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_10_3_1.gif",
          progress: {
            money: 3,
            trust: 2,
            fame: 1,
          },
        },
        {
          img: "/games/own-it/img/result_10_3_2.gif",
          progress: {
            money: -2,
            trust: -2,
            fame: 0,
          },
        },
        {
          img: "/games/own-it/img/result_10_3_3.gif",
          progress: {
            money: 0,
            trust: -1,
            fame: 0,
          },
        },
      ],
    ],
  },
  {
    img: "/games/own-it/img/question_11.gif",
    options: [
      [
        {
          img: "/games/own-it/img/result_11_1_1.gif",
          progress: {
            money: 1,
            trust: 1,
            fame: 0,
          },
        },
        {
          img: "/games/own-it/img/result_11_1_2.gif",
          progress: {
            money: -2,
            trust: -2,
            fame: -2,
          },
        },
        {
          img: "/games/own-it/img/result_11_1_3.gif",
          progress: {
            money: 3,
            trust: 3,
            fame: 1,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_11_2_1.gif",
          progress: {
            money: 7,
            trust: 5,
            fame: 5,
          },
        },
        {
          img: "/games/own-it/img/result_11_2_2.gif",
          progress: {
            money: -3,
            trust: -3,
            fame: -2,
          },
        },
        {
          img: "/games/own-it/img/result_11_2_3.gif",
          progress: {
            money: -2,
            trust: 1,
            fame: 0,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_11_3_1.gif",
          progress: {
            money: 3,
            trust: 3,
            fame: 1,
          },
        },
        {
          img: "/games/own-it/img/result_11_3_2.gif",
          progress: {
            money: 2,
            trust: 1,
            fame: 0,
          },
        },
        {
          img: "/games/own-it/img/result_11_3_3.gif",
          progress: {
            money: -2,
            trust: 0,
            fame: 0,
          },
        },
      ],
    ],
  },
  {
    img: "/games/own-it/img/question_12.gif",
    options: [
      [
        {
          img: "/games/own-it/img/result_12_1_1.gif",
          progress: {
            money: 3,
            trust: 2,
            fame: 0,
          },
        },
        {
          img: "/games/own-it/img/result_12_1_2.gif",
          progress: {
            money: -5,
            trust: -5,
            fame: -3,
          },
        },
        {
          img: "/games/own-it/img/result_12_1_3.gif",
          progress: {
            money: 1,
            trust: -2,
            fame: 0,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_12_2_1.gif",
          progress: {
            money: 0,
            trust: 3,
            fame: 1,
          },
        },
        {
          img: "/games/own-it/img/result_12_2_2.gif",
          progress: {
            money: -3,
            trust: -3,
            fame: -3,
          },
        },
        {
          lose: true,
        },
      ],
      [
        {
          img: "/games/own-it/img/result_12_3_1.gif",
          progress: {
            money: 2,
            trust: 2,
            fame: 2,
          },
        },
        {
          lose: true,
        },
        {
          lose: true,
        },
      ],
    ],
  },
  {
    img: "/games/own-it/img/question_13.gif",
    options: [
      [
        {
          img: "/games/own-it/img/result_13_1_1.gif",
          progress: {
            money: 2,
            trust: 5,
            fame: 7,
          },
        },
        {
          img: "/games/own-it/img/result_13_1_2.gif",
          progress: {
            money: -7,
            trust: -2,
            fame: -5,
          },
        },
        {
          img: "/games/own-it/img/result_13_1_3.gif",
          progress: {
            money: -3,
            trust: -3,
            fame: 3,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_13_2_1.gif",
          progress: {
            money: -2,
            trust: -5,
            fame: -5,
          },
        },
        {
          img: "/games/own-it/img/result_13_2_2.gif",
          progress: {
            money: -3,
            trust: 5,
            fame: 7,
          },
        },
        {
          img: "/games/own-it/img/result_13_2_3.gif",
          progress: {
            money: -3,
            trust: 0,
            fame: 0,
          },
        },
      ],
      [
        {
          img: "/games/own-it/img/result_13_3_1.gif",
          progress: {
            money: -1,
            trust: 0,
            fame: 3,
          },
        },
        {
          img: "/games/own-it/img/result_13_3_2gif",
          progress: {
            money: -2,
            trust: -2,
            fame: -3,
          },
        },
        {
          img: "/games/own-it/img/result_13_3_3.gif",
          progress: {
            money: -1,
            trust: 2,
            fame: 3,
          },
        },
      ],
    ],
  },
];

export const losingData = [
  {
    img: "/games/own-it/img/loser_1.gif",
  },
  {
    img: "/games/own-it/img/loser_2.gif",
  },
  {
    img: "/games/own-it/img/loser_3.gif",
  },
  {
    img: "/games/own-it/img/loser_4.gif",
  },
  {
    img: "/games/own-it/img/loser_5.gif",
  },
  {
    img: "/games/own-it/img/loser_6.gif",
  },
];

export const winningData = [
  {
    img: "/games/own-it/img/winner_1.gif",
  },
  {
    img: "/games/own-it/img/winner_2.gif",
  },
  {
    img: "/games/own-it/img/winner_3.gif",
  },
];
